<template>
    <div class="vue-tempalte">
        <div class="container mt-5 mb-5">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <form ref="serviceForm" @submit.prevent="onFormSubmit">
                        <h3>Добави услуга</h3>

                        <div class="form-group">
                            <label>Снимка</label>
                            <input type="file" class="form-control form-control-lg"  ref="file" v-on:change="handleFileUpload()" required>
                        </div>
                        <div class="form-group">
                            <label>Име</label>
                            <input type="text" class="form-control form-control-lg" v-model="service.name" required>
                        </div>

                        <div class="form-group">
                            <label>Описание</label>
                            <div class="editor-wrapper">
                                <vue-editor v-model="service.description"  required></vue-editor>
                            </div>
                        </div>

                        <div class="form-group">
                            <button class="btn btn-primary btn-block">Запази</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { db } from '../../firebase';
    import { VueEditor } from "vue2-editor";

    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                service: {
                    name: '',
                    description: '',
                    image: ''
                }
            }
        },
        methods: {
            onFormSubmit(event) {
                event.preventDefault();
                db.collection('services').add(this.service).then(() => {
                    alert("Успешно създадена услуга!");
                    this.service.name = null;
                    this.service.description = null;
                    this.$refs.file = null;
                }).catch((error) => {
                    console.log(error);
                });
            },

            handleFileUpload(){
                const reader = new FileReader();
                reader.readAsDataURL(this.$refs.file.files[0]);
                reader.onload = ()=> {
                    this.service.image = reader.result;
                };
            }
        }
    }
</script>
